import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/23. 몬트리올 본사.b0c79a744f2ab70be197.jpg`;
const Factory2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/24. 토론토 지점.a3927deb68d97d2c832b.jpg`;
const Factory3 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/25. 밴쿠버 지점.e62f039664d9e3f7974a.jpg`;
const Hat1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/26. 캐나다법인 모자.9374d7f7660f60ccc208.png`;
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const SalesCorporation = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} ename={"YoungAn Hat"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation">
                <div className="kor">위탁경영사업장</div>
                <div className="eng">Indirect Management Affiliates</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation">AJM</Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">AJM</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation2">
                  <div className="kor">아웃도아 캡 컴퍼니㈜</div>
                  <div className="eng">Outdoor Cap Co., Inc.</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation3">
                  <div className="kor">돌프만퍼시픽 ㈜</div>
                  <div className="eng">Dorfman Milano Company</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"해외 판매 사업장"} titleeng={"AJM"} website="https://www.ajmintl.com/"/>
            <div className="page-text">
              <div className="kor">
                <h2>캐나다 법인 / A.J.M International Ltd.</h2>
              </div>
              <div className="eng">
                <h2>Canada company / A.J.M International Ltd.</h2>
              </div>

              
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">몬트리올 본사</div>
                <div className="eng">Headquarters in Montreal</div>
              </div>
            </S.ImgHolderFullsize>

            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">토론토 지점</div>
                  <div className="eng">Toronto Branch</div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Factory3} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">벤쿠버 지점</div>
                  <div className="eng">Vancouver Branch</div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>

            <PageTitle titleko={"주요생산제품"} titleeng={"Major Production Products"}/>
            <S.ImgHolderFlex className="center">
              <img src={Hat1} alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요이력"} titleeng={"Major History "}/>

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor"><h2>A.J.M International Ltd. 법인개요</h2></div>
                    <div className="eng"><h2>Company Profile of A.J.M International Ltd.</h2></div>
                  </div>
                    <div className="kor">법인 설립: 1983년 6월 2일</div>
                    <div className="eng">Establishment : Jun 2nd, 1983</div>
                  <div className="kor">영안 합자: 1986년</div>
                  <div className="eng">Joint venture with YoungAn : 1986</div>
                </div>
              </div>
              <div className="kor">
                ※ 몬트리올 본사, 토론토 및 밴쿠버 지점(디스트리뷰션 센터) <br />
                ※ 캐나다 모자판매 시장점유율 1위 업체
                <br />
                ※ 프로모션 시장용 제품 위주의 스탁판매 시스템 운영
              </div>
              <div className="eng">
                ※ Montreal Headquarters, Toronto and Vancouver
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;branches(Distribution center)
                <br />
                ※ No.1 in the market share of cap sales in Canada
                <br />
                ※ Operating a stock sales system focusing on promotional
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;market products
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default SalesCorporation;
